const PENDING_REFERRAL_CODE_KEY = 'statureboost_pending_referral_code_v1'

export function getPendingReferralCode(): string {
  if (typeof window === 'undefined') {
    return ''
  }

  return localStorage.getItem(PENDING_REFERRAL_CODE_KEY) ?? ''
}

export function setPendingReferralCode(referralCode: string): void {
  if (typeof window === 'undefined') {
    return
  }

  const normalized = referralCode.trim().toUpperCase()
  if (normalized.length === 0) {
    return
  }

  localStorage.setItem(PENDING_REFERRAL_CODE_KEY, normalized)
}

export function clearPendingReferralCode(): void {
  if (typeof window === 'undefined') {
    return
  }

  localStorage.removeItem(PENDING_REFERRAL_CODE_KEY)
}
